import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=75c2a0b4&"
import script from "./CategoryModal.vue?vue&type=script&lang=js&"
export * from "./CategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c2a0b4')) {
      api.createRecord('75c2a0b4', component.options)
    } else {
      api.reload('75c2a0b4', component.options)
    }
    module.hot.accept("./CategoryModal.vue?vue&type=template&id=75c2a0b4&", function () {
      api.rerender('75c2a0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CategoryModal.vue"
export default component.exports